export const getTextError = (code: string) => {
  switch (code) {
    case "auth/user-not-found":
      return "El usuario no existe.";
    case "auth/wrong-password":
      return "La contraseña es incorrecta.";
  }
};
